import React, { useState, useContext, useEffect } from "react";
import { Link as RouterLink, useLocation } from "react-router-dom";

import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Divider from "@material-ui/core/Divider";
import { Badge, Avatar, Typography, IconButton } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
// Ícones no estilo "Rounded" (mais modernos). Os nomes locais continuam os
// mesmos para não mexer no resto do arquivo.
import DashboardOutlinedIcon from "@material-ui/icons/DashboardRounded";
import WhatsAppIcon from "@material-ui/icons/WhatsApp";
import SyncAltIcon from "@material-ui/icons/SyncAltRounded";
import SettingsOutlinedIcon from "@material-ui/icons/SettingsRounded";
import PeopleAltOutlinedIcon from "@material-ui/icons/PeopleAltOutlined";
import ContactPhoneOutlinedIcon from "@material-ui/icons/ContactPhoneRounded";
import QuestionAnswerOutlinedIcon from "@material-ui/icons/FlashOnRounded";
import MemoryOutlinedIcon from "@material-ui/icons/MemoryRounded";
import LocalOfferOutlinedIcon from "@material-ui/icons/LocalOfferRounded";
import StorageOutlinedIcon from "@material-ui/icons/StorageRounded";
import DeviceHubOutlinedIcon from "@material-ui/icons/AccountTreeRounded";
import ChatBubbleOutlineIcon from "@material-ui/icons/EmojiPeopleRounded";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import MenuBookRoundedIcon from "@material-ui/icons/MenuBookRounded";

import { i18n } from "../translate/i18n";
import { WhatsAppsContext } from "../context/WhatsApp/WhatsAppsContext";
import api from "../services/api";
import openSocket from "../services/socket-io";
import { AuthContext } from "../context/Auth/AuthContext";
import { Can } from "../components/Can";

const useStyles = makeStyles((theme) => ({
  // Barra lateral azul-noite (estilo Multi Tech) nos dois temas
  listItem: {
    borderRadius: 12,
    marginBottom: 3,
    padding: "6px 10px",
    color: "#cbd5e1",
    transition: "all 0.2s ease",
    "& .MuiListItemIcon-root": { minWidth: 46 },
    "& .MuiListItemText-primary": {
      fontSize: "0.86rem",
      fontWeight: 600,
      transition: "transform .2s ease",
    },
    "&:hover": {

      backgroundColor: "rgba(34,197,94,0.10)",

      "& .MuiListItemIcon-root, & svg": { color: "#4ade80 !important" },
      "& .MuiListItemText-primary": { color: "#ffffff", transform: "translateX(3px)" },
      // a caixinha do ícone acende e dá uma leve girada
      "& $listItemIcon": {
        backgroundColor: "rgba(34,197,94,0.18)",
        transform: "rotate(-8deg) scale(1.06)",
      },
    },
  },

  
  // Entrada em cascata dos itens (uma vez so, quando a barra aparece).
  menuAnimado: {
    "& li": { animation: "sbEntrar .45s cubic-bezier(.22,1,.36,1) both" },
    ...Object.fromEntries(
      Array.from({ length: 16 }, (_, i) => [
        `& li:nth-of-type(${i + 1})`,
        { animationDelay: `${0.05 + i * 0.045}s` },
      ])
    ),
  },
  listItemActive: {
    position: "relative",
    overflow: "hidden",
    // faixa de brilho que atravessa o item ativo de tempos em tempos
    "&::after": {
      content: '""',
      position: "absolute",
      top: 0,
      bottom: 0,
      left: 0,
      width: "35%",
      background: "linear-gradient(90deg, transparent, rgba(255,255,255,.16), transparent)",
      animation: "sbVarrer 4.5s ease-in-out infinite",
      pointerEvents: "none",
    },
    // satelite orbitando a caixinha do icone
    "& .MuiListItemIcon-root::after": {
      content: '""',
      position: "absolute",
      left: -5,
      top: "50%",
      width: 44,
      height: 44,
      marginTop: -22,
      borderRadius: "50%",
      background: "radial-gradient(circle at 50% 3px, #ffffff 0 2.2px, transparent 2.8px)",
      animation: "sbOrbita 5s linear infinite",
      pointerEvents: "none",
    },
    borderRadius: 12,
    marginBottom: 3,
    padding: "6px 10px",
    paddingRight: 28,
    background: "linear-gradient(90deg, rgba(22,163,74,0.30), rgba(22,163,74,0.06) 85%) !important",
    boxShadow: "inset 0 0 0 1px rgba(74,222,128,0.38), 0 0 18px rgba(34,197,94,0.12)",
    color: "#ffffff !important",
    "& .MuiListItemIcon-root": { minWidth: 46, position: "relative" },
    // a caixinha do icone acende em verde
    "& $listItemIcon": {
      backgroundColor: "rgba(34,197,94,0.22) !important",
      boxShadow: "inset 0 0 0 1px rgba(74,222,128,0.45)",
    },
    // ponto brilhante pulsando na direita
    "&::before": {
      content: '""',
      position: "absolute",
      right: 12,
      top: "50%",
      width: 6,
      height: 6,
      marginTop: -3,
      borderRadius: "50%",
      background: "#22c55e",
      boxShadow: "0 0 10px rgba(34,197,94,.9)",
      animation: "sbPontoVivo 1.8s ease-in-out infinite",
      zIndex: 1,
    },
    "&:hover": {
      background: "linear-gradient(90deg, rgba(22,163,74,0.38), rgba(22,163,74,0.10) 85%) !important",
    },
    "& .MuiListItemIcon-root, & svg": {
      color: "#4ade80 !important",
      fill: "currentColor",
    },
    "& .MuiListItemText-primary": {
      fontSize: "0.85rem",
      fontWeight: 700,
      color: "#ffffff",
    },
  },
  // Barra recolhida: o texto sai e o icone passa a ser centralizado dentro do
  // retangulo da selecao. Sem isso o ListItemText continua ocupando espaco
  // (so cortado pelo overflow) e empurra o icone para a esquerda do realce.
  // O texto e as bolinhas dividiam o mesmo espaco sem ninguem ceder, e as
  // bolinhas acabavam por cima da ultima letra. Agora o texto encolhe (com
  // reticencias, se precisar) e a area das bolinhas nunca e comprimida.
  itemTexto: {
    minWidth: 0,
    marginRight: 8,
    "& .MuiListItemText-primary": {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
  },
  areaBadges: {
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    flexWrap: "nowrap",
    gap: 6,
    marginLeft: "auto",
  },
  railColapsada: {
    "& .MuiListItem-root": {
      // padding zerado nos DOIS lados: qualquer sobra de recuo herdada do MUI
      // (gutters) ou do padding curto de listItem/listItemActive deixaria mais
      // verde de um lado do icone do que do outro.
      justifyContent: "center",
      paddingLeft: 0,
      paddingRight: 0,
    },
    "& .MuiListItemIcon-root": {
      // ocupa a largura toda do item e centraliza o svg dentro dela, em vez de
      // depender da largura natural do icone.
      minWidth: 0,
      width: "100%",
      margin: 0,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    "& .MuiListItemText-root": {
      display: "none",
    },
    // recolhida, o icone fica centralizado: a orbita sairia do lugar
    "& .MuiListItemIcon-root::after": { display: "none" },
    "& .MuiListItem-root::before": { display: "none" },
    // as bolinhas de contagem tambem saem: com o texto escondido elas
    // desalinhariam o icone. O ripple do MUI fica de fora da regra.
    "& .MuiListItem-root > span:not(.MuiTouchRipple-root)": {
      display: "none",
    },
  },
  // ícone dentro de uma caixinha arredondada
  listItemIcon: {
    width: 34,
    height: 34,
    padding: 8,
    borderRadius: 10,
    color: "#94a3b8",
    backgroundColor: "rgba(255,255,255,0.05)",
    transition: "background-color .2s ease, transform .25s ease, color .2s ease",
  },
  listItemText: {
    "& .MuiListItemText-primary": {
      fontSize: "0.85rem",

      fontWeight: 600,
      color: "#cbd5e1",
    },
  },
  sectionTitle: {
    fontSize: "0.68rem",
    fontWeight: 700,
    color: "rgba(226,232,240,0.42)",
    textTransform: "uppercase",
    letterSpacing: "0.05em",
    padding: "20px 16px 8px 16px",
  },
  divider: {
    margin: "8px 16px",
    backgroundColor: "rgba(148,163,184,0.12)",
  },
  bottomSection: {
    borderTop: "1px solid rgba(148,163,184,0.12)",
    paddingTop: 8,
    marginTop: "auto",
  },
  userSection: {
    display: "flex",
    alignItems: "center",
    padding: "12px 16px",
    borderTop: "1px solid rgba(148,163,184,0.12)",
    marginTop: 8,
  },
  userAvatar: {
    width: 36,
    height: 36,
    backgroundColor: "#1E9855",
    fontSize: "0.85rem",
    fontWeight: 700,
  },
  userInfo: {
    marginLeft: 12,
    flex: 1,
    overflow: "hidden",
  },
  userName: {
    fontSize: "0.85rem",
    fontWeight: 600,
    color: "#e2e8f0",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  userEmail: {
    fontSize: "0.75rem",
    color: "#94a3b8",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
}));

const CORES_BOLINHA = {
  ia: "#f59e0b",
  humano: "#2563eb",
};

const Bolinha = ({ valor, tipo, titulo }) => {
  if (!valor) return null;

  return (
    <span
      title={titulo}
      style={{
        backgroundColor: CORES_BOLINHA[tipo],
        color: "#fff",
        borderRadius: 10,
        fontSize: "0.68rem",
        fontWeight: 700,
        lineHeight: "18px",
        minWidth: 20,
        height: 18,
        padding: "0 6px",
        textAlign: "center",
        display: "inline-block",
        flexShrink: 0,
      }}
    >
      {valor > 99 ? "99+" : valor}
    </span>
  );
};

function ListItemLink(props) {
  const { icon, primary, to, className, badges } = props;
  const classes = useStyles();

  const renderLink = React.useMemo(
    () =>
      React.forwardRef((itemProps, ref) => (
        <RouterLink to={to} ref={ref} {...itemProps} />
      )),
    [to]
  );

  return (
    <li style={{ listStyle: "none" }}>
      <ListItem button component={renderLink} className={className}>
        {icon ? <ListItemIcon>{icon}</ListItemIcon> : null}
        <ListItemText primary={primary} className={classes.itemTexto} />
        {badges ? <span className={classes.areaBadges}>{badges}</span> : null}
      </ListItem>
    </li>
  );
}

const MainListItems = (props) => {
  const { drawerClose, drawerOpen } = props;
  const { whatsApps } = useContext(WhatsAppsContext);
  const { user, handleLogout } = useContext(AuthContext);
  const [connectionWarning, setConnectionWarning] = useState(false);
  const [contadores, setContadores] = useState({ espera: 0, humano: 0 });
  const location = useLocation();

  
  useEffect(() => {
    let vivo = true;

    const buscar = async () => {
      try {
        const { data } = await api.get("/tickets/contadores");
        if (vivo) setContadores(data);
      } catch {
        
      }
    };

    buscar();

    const socket = openSocket();

    

    
    const aplicar = (dados) => {
      if (!vivo || !dados) return;
      setContadores({
        espera: Number(dados.espera) || 0,
        humano: Number(dados.humano) || 0,
      });
    };

    socket.on("ticketCounters", aplicar);
    socket.on("ticket", buscar);
    socket.on("aiNotification", buscar);

    return () => {
      vivo = false;
      socket.off("ticketCounters", aplicar);
      socket.off("ticket", buscar);
      socket.off("aiNotification", buscar);

      

    };
  }, []);

  const classes = useStyles();

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (whatsApps.length > 0) {

        

        

        

        

        // Número inativo não é problema: foi o admin que desligou, de propósito.
        // Contá-lo aqui deixava o "!" aceso para sempre depois de aposentar um
        // chip banido, e o alerta perdia a graça — quem vê sempre, não vê.
        const offlineWhats = whatsApps.filter((whats) => {
          if (whats.ativa === false) return false;
          return (
            whats.status === "DISCONNECTED" ||
            whats.status === "TIMEOUT"
          );
        });
        setConnectionWarning(offlineWhats.length > 0);
      } else {
        // Sem nenhuma conexão cadastrada não há o que alertar. Antes o estado
        // antigo ficava preso: excluir a última conexão não apagava o "!".
        setConnectionWarning(false);
      }
    }, 2000);
    return () => clearTimeout(delayDebounceFn);
  }, [whatsApps]);

  const isActive = (path) => {
    if (path === "/") return location.pathname === "/";
    return location.pathname.startsWith(path);
  };

  const getItemClass = (path) =>
    isActive(path) ? classes.listItemActive : classes.listItem;

  const getIconClass = () => classes.listItemIcon;

  return (
    <div
      onClick={drawerClose}
      className={`sb-anima ${classes.menuAnimado} ${drawerOpen ? "" : classes.railColapsada}`}
      style={{ display: "flex", flexDirection: "column", height: "100%", padding: "0 8px" }}
    >
      <div style={{ flex: 1 }}>
        {drawerOpen && (
          <Typography className={classes.sectionTitle}>
            Menu
          </Typography>
        )}

        <ListItemLink
          to="/"
          primary="Dashboard"
          icon={<DashboardOutlinedIcon className={getIconClass()} />}
          className={getItemClass("/")}
        />
        <ListItemLink
          to="/regras"
          primary="Regras"
          icon={<MenuBookRoundedIcon className={getIconClass()} />}
          className={getItemClass("/regras")}
        />
        <ListItemLink
          to="/atendimentos"
          primary={i18n.t("mainDrawer.listItems.tickets")}
          icon={<WhatsAppIcon className={getIconClass()} />}
          className={getItemClass("/atendimentos")}
          badges={
            <>
              <Bolinha
                valor={contadores.espera}
                tipo="ia"
                titulo={`${contadores.espera} cliente(s) na espera — a assistente está atendendo`}
              />
              <Bolinha
                valor={contadores.humano}
                tipo="humano"
                titulo={`${contadores.humano} cliente(s) precisando de atendimento humano`}
              />
            </>
          }
        />
        <ListItemLink
          to="/contatos"
          primary={i18n.t("mainDrawer.listItems.contacts")}
          icon={<ContactPhoneOutlinedIcon className={getIconClass()} />}
          className={getItemClass("/contatos")}
        />
        <ListItemLink
          to="/respostas-rapidas"
          primary={i18n.t("mainDrawer.listItems.quickAnswers")}
          icon={<QuestionAnswerOutlinedIcon className={getIconClass()} />}
          className={getItemClass("/respostas-rapidas")}
        />
        <ListItemLink
          to="/etiquetas"
          primary="Etiquetas"
          icon={<LocalOfferOutlinedIcon className={getIconClass()} />}
          className={getItemClass("/etiquetas")}
        />

        {}
        <ListItemLink
          to="/saudacoes"
          primary="Saudações"
          icon={<ChatBubbleOutlineIcon className={getIconClass()} />}
          className={getItemClass("/saudacoes")}
        />

        <Can
          role={user.profile}
          perform="drawer-admin-items:view"
          yes={() => (
            <>
              {drawerOpen && (
                <Typography className={classes.sectionTitle}>
                  {i18n.t("mainDrawer.listItems.administration")}
                </Typography>
              )}

              {(user.profile === "admin" || user.profile === "operador") && (
              <ListItemLink
                to="/conexoes"
                primary={i18n.t("mainDrawer.listItems.connections")}
                icon={
                  <Badge badgeContent={connectionWarning ? "!" : 0} color="error" overlap="rectangular">
                    <SyncAltIcon className={getIconClass()} />
                  </Badge>
                }
                className={getItemClass("/conexoes")}
              />
              )}
              {}
              {user.profile === "admin" && (
              <ListItemLink
                to="/fluxos-visuais"
                primary="Fluxos Visuais"
                icon={<DeviceHubOutlinedIcon className={getIconClass()} />}
                className={getItemClass("/fluxos-visuais")}
              />
              )}
              <ListItemLink
                to="/base-clientes"
                primary="Base de Clientes"
                icon={<StorageOutlinedIcon className={getIconClass()} />}
                className={getItemClass("/base-clientes")}
              />
              {user.profile === "admin" && (
              <ListItemLink
                to="/chatbot-ia"
                primary="I.A"
                icon={<MemoryOutlinedIcon className={getIconClass()} />}
                className={getItemClass("/chatbot-ia")}
              />
              )}
              <ListItemLink
                to="/configuracoes"
                primary={i18n.t("mainDrawer.listItems.settings")}
                icon={<SettingsOutlinedIcon className={getIconClass()} />}
                className={getItemClass("/configuracoes")}
              />
            </>
          )}
        />
      </div>

    </div>
  );
};

export default MainListItems;
